var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
let TitleComponent = class TitleComponent extends LitElement {
    render() {
        return html `
            <h1>Echos of Players Past</h1>
            <button
                @click=${() => {
            this.dispatchEvent(new CustomEvent('hide-title', {
                bubbles: true,
                composed: true,
            }));
        }}
            >Start Game</button>
        `;
    }
};
TitleComponent.styles = css `
        :host {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        label {
            font-weight: bold;
        }

        player-canvas {
            width: 30vmin;
            height: 30vmin;
        }

        .form {
            margin-top: 20px;
        }

        .form-row {
            margin: 0.5em 0;
        }

        .go-button {
            margin-top: 20px;
            padding: 10px 20px;
            font-size: 1.5em;
        }
    `;
TitleComponent = __decorate([
    customElement('title-component')
], TitleComponent);
export { TitleComponent };
